import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Upload,
  Modal,
  notification,
  Flex,
  Spin,
  Select
} from "antd";
import {
  SearchOutlined,
  FileExcelOutlined,
  UploadOutlined,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../store";
import {
  deleteDataEmployeeRequest,
  getEmployeeReportRequest,
  resetMessageEmp,
  updateUploadEmployeeRequest,
  uploadEmployeeRequest,
} from "../slices/employee";
import { Link } from "react-router-dom";
import { UploadFile, UploadFileStatus, RcFile } from "antd/es/upload/interface";



const ListEmployee: React.FC = () => {
  const dispatch = useDispatch();
  const {
    loading,
    message,
    isChange,
    employees,
    uploadEmployee,
    updateEmployee,
    authData,
    deletedData
  } = useTypedSelector((state) => {
    return {
      loading: state.Employee.pageIsLoading,
      message: state.Employee.message,
      isChange: state.Employee.postEmployeeData,
      employees: state.Employee.listEmployees,
      uploadEmployee: state.Employee.uploadEmployee,
      updateEmployee: state.Employee.updateEmployee,
      authData: state.Auth.loginData,
      deletedData: state.Employee.deletedRes
    };
  });
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(employees);
  const [isModalUpload, setIsModalUpload] = useState<boolean>(false);
  const [isModalUpdate, setIsModalUpdate] = useState<boolean>(false);
  const [isModalDelete, setIsModalDelete] = useState<boolean>(false);
  const [idDelete, setIdDelete] = useState<string>("");
  const [isUploadProcess, setIsUploadProcess] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [fileUpdateList, setFileUpdateList] = useState<UploadFile<any>[]>([]);

  

  console.log("AUTH", authData);

  const deleteHandler = () => {
    dispatch(deleteDataEmployeeRequest({employeeId: idDelete, deletorId: authData.employeeId}) as any)
    
  }

  const openModalDeleteHandler = (id: string) => {
    console.log(id);
    setIdDelete(id)
    setIsModalDelete(true)
  }
  
  const handleSearch = (value: string) => {
    setSearchText(value);
    if (!value) {
      setFilteredData(employees);
      return;
    }

    const filtered = employees.filter((employee) => {
      const fullname = employee.fullname?.toLowerCase() || "";
      const eid = employee.eid?.toLowerCase() || "";
      const location = employee.location?.toLowerCase() || "";
      return (
        fullname.includes(value.toLowerCase()) ||
        eid.includes(value.toLowerCase()) ||
        location.includes(value.toLowerCase())
      );
    });

    setFilteredData(filtered);
  };

  const onChange = (value: string) => {
    // console.log(`selected ${value}`);
    if (value !== "all") {
      const filtered = employees.filter(({ status }) => {
        // console.log("EPLO", status);
        return status === value; // <-- tambahkan return
      });
      setFilteredData(filtered);
    }else{
      setFilteredData(employees);
    }
  };
  
  
  const onSearch = (value: string) => {
    console.log('search:', value);
  };
  

  // const handleExportToExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Employees");
  //   XLSX.writeFile(wb, "employees.xlsx");
  // };
  const handleExportToExcel = () => {
    const flattened = filteredData.map((item) => ({
      ...item,
      emergency_contact: item.emergency_contact
        ? `${item.emergency_contact.phone || ''}, ${item.emergency_contact.name || ''}, ${item.emergency_contact.status || ''}`
        : '',
      emergency_contact_second: item.emergency_contact_second
        ? `${item.emergency_contact_second.phone || ''}, ${item.emergency_contact_second.name || ''}, ${item.emergency_contact_second.status || ''}`
        : '',
    }));
  
    const ws = XLSX.utils.json_to_sheet(flattened);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees");
    XLSX.writeFile(wb, "employees.xlsx");
  };
  
  

  console.log("EM", employees);
  console.log("EF", filteredData);
  const columns = [
    {
      title: "EID",
      dataIndex: "eid",
      key: "eid",
      sorter: (a: any, b: any) => a.eid.localeCompare(b.eid),
      render: (eid: any) => (
        <Link to={`/employee/${eid}`} style={{ color: "#1890ff" }}>
          {eid}
        </Link>
      ),
    },
    {
      title: "Number ID",
      dataIndex: "numberID",
      key: "numberID",
      sorter: (a: any, b: any) => a.numberID.localeCompare(b.numberID),
    },
    {
      title: "Fullname",
      dataIndex: "fullname",
      key: "fullname",
      sorter: (a: any, b: any) => a.fullname.localeCompare(b.fullname),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: (a: any, b: any) =>
        (a.location || "").localeCompare(b.location || ""),
    },
    {
      title: "Approval Name",
      dataIndex: "approvalName",
      key: "approvalName",
      sorter: (a: any, b: any) =>
        (a.approvalName || "").localeCompare(b.approvalName || ""),
    },
    {
      title: "Approval ID",
      dataIndex: "approvalId",
      key: "approvalId",
      sorter: (a: any, b: any) =>
        (a.approvalId || "").localeCompare(b.approvalId || ""),
    },
    {
      title: "Date of Birth",
      dataIndex: "dateOfBirth",
      key: "dateOfBirth",
      sorter: (a: any, b: any) =>
        new Date(a.dateOfBirth).getTime() - new Date(b.dateOfBirth).getTime(),
    },
    {
      title: "Place of Birth",
      dataIndex: "placeOfBirth",
      key: "placeOfBirth",
      sorter: (a: any, b: any) => a.placeOfBirth.localeCompare(b.placeOfBirth),
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      sorter: (a: any, b: any) => a.nationality.localeCompare(b.nationality),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      sorter: (a: any, b: any) =>
        (a.gender || "").localeCompare(b.gender || ""),
    },
    {
      title: "Religion",
      dataIndex: "religion",
      key: "religion",
      sorter: (a: any, b: any) =>
        (a.religion || "").localeCompare(b.religion || ""),
    },
    {
      title: "Marital Status",
      dataIndex: "marital_status",
      key: "marital_status",
      sorter: (a: any, b: any) =>
        (a.marital_status || "").localeCompare(b.marital_status || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
    },
    {
      title: "ID City",
      dataIndex: "idCity",
      key: "idCity",
      sorter: (a: any, b: any) => a.idCity.localeCompare(b.idCity),
    },
    {
      title: "Domicile City",
      dataIndex: "domicileCity",
      key: "domicileCity",
      sorter: (a: any, b: any) => a.domicileCity.localeCompare(b.domicileCity),
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: (a: any, b: any) => a.department.localeCompare(b.department),
    },
    {
      title: "Job",
      dataIndex: "job",
      key: "job",
      sorter: (a: any, b: any) => a.job.localeCompare(b.job),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a: any, b: any) =>
        (a.status || "").localeCompare(b.status || ""),
    },
    {
      title: "Type Job",
      dataIndex: "typeJob",
      key: "typeJob",
      sorter: (a: any, b: any) => a.typeJob.localeCompare(b.typeJob),
    },
    {
      title: "Join Date",
      dataIndex: "join_date",
      key: "join_date",
      sorter: (a: any, b: any) =>
        (a.join_date || "").localeCompare(b.join_date || ""),
    },
    {
      title: "Device",
      dataIndex: "deviceId",
      key: "deviceId",
      sorter: (a: any, b: any) =>
        (a.deviceId || "").localeCompare(b.deviceId || ""),
    },
    {
      title: "Action",
      // dataIndex: "eid",
      // key: "eid",
      render: (record: any) => (
        <Button type="primary" danger onClick={() => { openModalDeleteHandler(record.eid) }} >Delete</Button>
      ),
    },
  ];

  useEffect(() => {
    // Dispatch data dari API ketika komponen pertama kali di-mount
    dispatch(getEmployeeReportRequest() as any);
    setIsModalUpload(false);
  }, [dispatch, deletedData]);

  useEffect(() => {
    // Perbarui filteredData setiap kali employees berubah
    if (employees.length > 0) {
      setFilteredData(employees);
    }
  }, [employees]);

  console.log("FD", filteredData);

  const uploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setFileList((prevFileList) =>
        prevFileList.filter((f) => f.uid !== file.uid)
      );
    },
    beforeUpload: (file: File & RcFile) => {
      const uploadFile: UploadFile<any> = {
        uid: file.uid || file.name, // Gunakan UID atau nama file
        name: file.name,
        status: "done" as UploadFileStatus,
        originFileObj: file,
      };
      setFileList([uploadFile]);
      return false; // Prevent automatic upload
    },
    fileList,
  };

  const updateProps = {
    onRemove: (file: UploadFile<any>) => {
      setFileUpdateList((prevFileList) =>
        prevFileList.filter((f) => f.uid !== file.uid)
      );
    },
    beforeUpload: (file: File & RcFile) => {
      const uploadFile: UploadFile<any> = {
        uid: file.uid || file.name, // Gunakan UID atau nama file
        name: file.name,
        status: "done" as UploadFileStatus,
        originFileObj: file,
      };
      setFileUpdateList([uploadFile]);
      return false; // Prevent automatic upload
    },
    fileUpdateList,
  };

  const downloadEmployeeTemplate = () => {
    const headers = [
      "employeeId",
      "fullname",
      "joinDate",
      "department",
      "location",
      "number_id",
      "place_of_birth",
      "date_of_birth",
      "gender",
      "religion",
      "phone",
      "street",
      "local_unit",
      "sub_district",
      "district",
      "city",
      "province",
      "domicile",
      "marital_status",
      "email",
      "report_to",
      "organisation"
    ];
    const data = [
      [
        "DB0001",
        "ABDUL RAHMAN",
        "2024-11-21",
        "FOOD DIVISION",
        "ANTARASA TRIBECA - JKT (harus sama dengan nama outlet)",
        "NO KTP (harus text) exp: 1271140308930003",
        "JAKARTA",
        "1993-08-03",
        "MALE / FEMALE",
        "ISLAM",
        "628577370813 (harus text)",
        "dailybox raya",
        "RT/RW",
        "KELURAHAN",
        "KECAMATAN",
        "KOTA",
        "PROVINSI",
        "alamat lengkap tempat tinggal",
        "BELUM MENIKAH / MENIKAH",
        "email (wajib)",
        "DB0001 (ID atasan)",
        "PT SENDOK GARPU INTERNASIONAL"
      ],
    ];

    // Create a worksheet with the headers and sample data
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Template");

    // Write the workbook to a file and trigger the download
    XLSX.writeFile(workbook, "employee_template.xlsx");
  };

  const handleUpload = () => {
    setIsUploadProcess(true);
    if (fileList.length === 0) {
      notification.warning({
        message: "Please select a file before uploading.",
      });
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("data", file.originFileObj as File);
        dispatch(uploadEmployeeRequest(formData) as any);
      }
    });
  };

  const handleUpdate = () => {
    setIsUploadProcess(true);
    if (fileUpdateList.length === 0) {
      notification.warning({
        message: "Please select a file before uploading.",
      });
      return;
    }

    const formData = new FormData();
    fileUpdateList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("data", file.originFileObj as File);
        dispatch(updateUploadEmployeeRequest(formData) as any);
      }
    });
  };

  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Input
          placeholder="Search by Fullname or EID"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          prefix={<SearchOutlined />}
          style={{ maxWidth: 300 }}
        />
        <Select
    showSearch
    placeholder="Status"
    optionFilterProp="label"
    onChange={onChange}
    onSearch={onSearch}
    options={[
      {
        value: 'all',
        label: '--All--',
      },
      {
        value: 'active',
        label: 'Active',
      },
      {
        value: 'inactive',
        label: 'Inactive',
      },
    ]}
  />

        <div>
          <Button
            icon={<DownloadOutlined />}
            style={{
              backgroundColor: "#57a773",
              color: "white",
              marginRight: 10,
            }}
            onClick={() => downloadEmployeeTemplate()}
          >
            Download Template Excel
          </Button>
          <Button
            icon={<UploadOutlined />}
            style={{
              backgroundColor: "#57a773",
              color: "white",
              marginRight: 10,
            }}
            onClick={() => setIsModalUpload(true)}
          >
            Upload Employee
          </Button>
          <Button
            icon={<UploadOutlined />}
            style={{
              backgroundColor: "#57a773",
              color: "white",
              marginRight: 10,
            }}
            onClick={() => setIsModalUpdate(true)}
          >
            Update Employee
          </Button>
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            style={{ backgroundColor: "#00a65a", borderColor: "#00a65a" }}
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
        </div>
      </Space>
      <Table
        columns={columns}
        dataSource={filteredData ? filteredData : employees}
        scroll={{ x: "max-content" }}
        onRow={(record) => {
          console.log("AAAAAA",record);
          
          if (record.status === 'inactive') {
            return {
              style: {
                backgroundColor: 'rgba(255, 0, 0, 0.5)',
                // pointerEvents: 'none',
                opacity: 0.5,
              },
            };
          }
          return {};
        }}
      
      // rowKey="eid"
      />
      <Modal
        title="Upload Employee Confirm"
        open={isModalUpload}
        footer={null}
        onCancel={() => {
          setIsModalUpload(false);
          setIsUploadProcess(false);
          setFileList([]);
        }}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px", // Sesuaikan tinggi modal
        }}
      >
        <Upload {...uploadProps} accept=".xlsx,.xls">
          <Button
            icon={<UploadOutlined />}
            style={{ width: 300, marginBottom: 20 }}
          >
            Select File
          </Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleUpload}
          style={{
            backgroundColor: "#217346", // Warna hijau khas Excel
            borderColor: "#217346", // Sesuaikan border dengan warna latar belakang
            color: "#fff",
            width: 300, // Warna teks putih
          }}
        >
          {!loading && <>Upload Employee</>}
          {loading && (
            <>
              <Flex align="center" gap="middle">
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              </Flex>
            </>
          )}
        </Button>
        {uploadEmployee && isUploadProcess === true && (
          <>
            <p style={{ color: "red", marginBottom: 0 }}>
              FAIL : {uploadEmployee.fail}
            </p>
            <p style={{ color: "green", marginTop: 0 }}>
              SUCCESS : {uploadEmployee.success}
            </p>
          </>
        )}
      </Modal>
      <Modal
        title="Update Employee Confirm"
        open={isModalUpdate}
        footer={null}
        onCancel={() => {
          setIsModalUpdate(false);
          setIsUploadProcess(false);
          setFileUpdateList([]);
        }}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px", // Sesuaikan tinggi modal
        }}
      >
        <Upload {...updateProps} accept=".xlsx,.xls">
          <Button
            icon={<UploadOutlined />}
            style={{ width: 300, marginBottom: 20 }}
          >
            Select File
          </Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleUpdate}
          style={{
            backgroundColor: "#217346", // Warna hijau khas Excel
            borderColor: "#217346", // Sesuaikan border dengan warna latar belakang
            color: "#fff",
            width: 300, // Warna teks putih
          }}
        >
          {!loading && <>Update Employee</>}
          {loading && (
            <>
              <Flex align="center" gap="middle">
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              </Flex>
            </>
          )}
        </Button>
        {updateEmployee && isUploadProcess === true && (
          <>
            <p style={{ color: "red", marginBottom: 0 }}>
              FAIL : {updateEmployee.fail}
            </p>
            <p style={{ color: "green", marginTop: 0 }}>
              SUCCESS : {updateEmployee.success}
            </p>
          </>
        )}
      </Modal>
      <Modal open={isModalDelete} onCancel={() => { setIsModalDelete(false); dispatch(resetMessageEmp()) }} onOk={() => {deleteHandler()}} okButtonProps={{disabled: message? true : false}}>
        <div>
          <h2 style={{ color: "red" }}>Perhatian..!</h2>
          <div style={{ border: "1px solid grey", padding: 15, borderRadius: 5, paddingTop: 20, paddingBottom: 30 }}>
            <p style={{ margin: 0 }}>Proses ini akan menhapus Data terkait secara <span style={{ fontWeight: "bold" }}>PERMANENT</span></p>
            <p style={{ margin: 0 }}><span style={{ fontWeight: "bold" }}>HATI-HATI</span> data yang sudah dihapus tidak dapat di <span style={{ fontWeight: "bold" }}>Kembalikan</span></p>
            <p style={{ margin: 0 }}>Silahkan <span style={{ fontWeight: "bold" }}>Periksa</span> Kembali data ini <span style={{ fontWeight: "bold" }}>Pastikan aman</span> untuk dihapus</p>
          </div>
          {loading ? <p style={{fontSize: 20, color: "yellow"}}>Process...</p> : message ? <p style={{fontSize: 20, color: "green"}}>{message}</p> : <p></p>}
        </div>
      </Modal>
    </div>
  );
};

export default ListEmployee;
